import { Button, Grid, Group } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import AccountBillingFields from './AccountBillingFields';

const ActivateDomainBillingInformationTab = ({ accountId, handleChangeTab }) => {
  const fetch = useFetch();

  const [billingInfo, setBillingInfo] = useState();
  const [working, setWorking] = useState(false);

  const [error, setError] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}`)
      .then(({ account }) => {
        setBillingInfo(account);
      })
      .catch(setError);
  }, [accountId, fetch]);

  const save = () => {
    setWorking(true);
    fetch(`/api/admin/accounts/${accountId}`, {
      method: 'PUT',
      body: JSON.stringify(billingInfo),
    })
      .then(() => {
        setWorking(false);
        handleChangeTab({ name: 'billingInformation', status: 'completed' });
      })
      .catch(setError)
      .finally(() => setWorking(false));
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!billingInfo) {
    return;
  }

  return (
    <Grid>
      <Grid.Col>
        <Grid.Col span={12} ta="center">
          <p>Please ensure the following information is filled out correctly.</p>
        </Grid.Col>
        <form>
          <AccountBillingFields billingInfo={billingInfo} setBillingInfo={setBillingInfo} error={error} />
          <Group justify="flex-end" mt="md">
            <Button
              disabled={
                working ||
                !billingInfo.addressLine1 ||
                !billingInfo.city ||
                !billingInfo.country ||
                !billingInfo.invoiceRecipients?.length > 0 ||
                !billingInfo.contactName ||
                !billingInfo.contactPhoneNumber ||
                !billingInfo.invoiceCurrency
              }
              onClick={save}
              rightSection={<IconChevronRight size={14} />}
            >
              Next
            </Button>
          </Group>
        </form>
      </Grid.Col>
    </Grid>
  );
};

export default ActivateDomainBillingInformationTab;
